<div class="signup _text-md _w-full _h-full">
    <app-tabs
        [setActiveTabIndexAs]="activeTab"
        [buttonsData]="tabButtons"
        [componentClassname]="'_drawer _drawer-no-toggle-btn _flex _flex-col _items-center _h-full _w-full' + (mobileDrawerOpen ? ' _drawer-open' : '')"
        tabsClassname="_tabs-x-full _h-form-field"
        buttonClassname="_button-reset _bg-primary-1 sm:_bg-transparency-black-25 _text-white"
        tabContentContainerClassname="_bg-white sm:_bg-transparency-black-50 _px-4 xs:_px-12 sm:_px-6 md:_px-12 _py-5 _flex-1 _w-full _max-h-login-container-mobile sm:_max-h-login-container _overflow-y-scroll _no-scrollbar"
        buttonActiveClassname="_bg-grayscale-white sm-max:_text-grayscale-black sm:_bg-transparency-black-50"
        (tabSwitched)="trackCurrentTab($event)">

        <ng-container slot="tab-buttons" *ngIf="mobileView">
            <button
                (click)="closeMobileDrawer()"
                class="_button-reset _bg-primary-1 _text-white _flex-grow-0"
                data-tab-button-no-events>
                <i class="fa-sharp fa-light fa-chevrons-right"></i>
            </button>
        </ng-container>

        <ng-container slot="tab-content">
            <div data-tab-content-index="1">
                <div class="sm-max:_max-w-500px _mx-auto _relative">

                    <div class="_h3 _mb-4"
                         [ngClass]="darkTheme ? '_text-white' : '_text-black'">
                         {{
                            isSelfSingupForHotel ?
                            'Log in to access your hotel or villa listing.' :
                            resetPasswordView ?
                            'Reset your password. ' :
                            'Log in to book from over 3,000 luxury listings.'
                         }}
                    </div>

                    <div *ngIf="signupSuccess || onloadMessage?.type === 'success'"
                         class="_my-4 _w-full _text-center _text-black _pill _bg-white _border-2 _border-green-600">
                        <i class="fa-regular fa-sharp fa-circle-check _text-green-600 _mr-1"></i>
                        {{ signupSuccess ? 'Your account has been created.' : onloadMessage.message }}
                    </div>

                    <div *ngIf="loginError || onloadMessage?.type === 'error'"
                         class="_my-4 _w-full _text-center _text-black _pill _bg-white _border _border-error-red">
                        <i class="fa-regular fa-sharp fa-circle-xmark _text-error-red _mr-1"></i>
                        {{ loginError ? loginErrorMessage : onloadMessage.message }}
                    </div>

                    <form *ngIf="!resetPasswordView" [formGroup]="loginForm" (ngSubmit)="login()">
                        <app-form-input-email
                            [darkTheme]="darkTheme"
                            fieldId="loginEmail"
                            appTrackInput [metric]="'User Email Entered'"
                            [value]="signupEmailValue">
                        </app-form-input-email>
                        
                        <app-form-input-password
                            [darkTheme]="darkTheme"
                            fieldId="loginPassword"
                            appTrackInput [metric]="'User Password Entered'"
                            [value]="signupPasswordValue">
                        </app-form-input-password>

                        <app-form-checkbox
                            fieldId="loginRememberMe"
                            [checked]="true"
                            appTrackClick [metric]="'User Remember Me Clicked'"
                            value="remember_me"
                            modifierClassname="_mt-5 _mb-6">
                            <span
                                class="label _ml-2 _cursor-pointer"
                                [ngClass]="darkTheme ? '_text-white' : '_text-black'">
                                Remember me
                            </span>
                        </app-form-checkbox>

                        <app-button
                            appTrackClick [metric]="'User Login Clicked'"
                            [disabled]="!loginForm.valid"
                            [loading]="loginInProgress === 'user-credentials'"
                            [type]="darkTheme ? 'primary-dark' : 'primary'"
                            htmlType="submit"
                            modifierClassNames="_w-full _mb-4">
                            Login
                        </app-button>
                    </form>

                    <form *ngIf="resetPasswordView" [formGroup]="resetPasswordForm">
                        
                        <ng-container *ngIf="!resetPasswordSuccess">
                            <app-form-input-email
                                [darkTheme]="darkTheme"
                                label="Account email address"
                                fieldId="passwordResetEmail"
                                appTrackInput [metric]="'Password Reset Email Entered'"
                                [value]="signupEmailValue">
                            </app-form-input-email>

                            <div class="_mb-6"></div>
                            
                            <app-button
                                appTrackClick [metric]="'Password Reset Email Clicked'"
                                [disabled]="!resetPasswordForm.valid"
                                [loading]="resetPasswordInProgress"
                                [onClick]="resetPassword.bind(this)"
                                [type]="darkTheme ? 'primary-dark' : 'primary'"
                                modifierClassNames="_w-full _mb-4">
                                Send reset email
                            </app-button>
                        </ng-container>

                        <ng-container *ngIf="resetPasswordSuccess">
                            <div class="_my-4 _w-full _text-center _text-black _pill _bg-white _border-2 _border-green-600">
                                <i class="fa-regular fa-sharp fa-circle-check _text-green-600 _mr-1"></i>
                                Password reset email sent.
                            </div>
                            <div class="_mb-6" [ngClass]="darkTheme ? '_text-white' : '_text-black'">
                                <p class="_mb-2">We have just sent you an email to reset your password.</p> 
                                <p>Please ensure you check your spam folder if you do not receive an email shortly.</p>
                            </div>
                        </ng-container>
                    </form>

                    <div *ngIf="!resetPasswordView" class="_flex _flex-col _items-center _gap-2"
                        [ngClass]="darkTheme ? '_text-white' : '_text-black'">
                        <div class="_flex" *ngIf="selfSignup">
                            Don't have an account?
                            <span class="_ml-2 _underline"
                                [ngClass]="darkTheme ? '_link-dark' : '_link'"
                                (click)="trackCurrentTab(2)"
                                (keydown.enter)="trackCurrentTab(2)"
                                tabindex="0">
                                Sign up
                            </span>
                        </div>

                        <div class="_flex _mb-2">
                            Forgot your password?
                            <span class="_ml-2 _underline"
                                [ngClass]="darkTheme ? '_link-dark' : '_link'"
                                (click)="toggleResetPasswordView(true)"
                                tabindex="0">
                                Reset
                            </span>
                        </div>
                    </div>

                    <div *ngIf="resetPasswordView" class="_flex _flex-col _items-center _gap-2" 
                        [ngClass]="darkTheme ? '_text-white' : '_text-black'">
                        <span *ngIf="resetPasswordSuccess" class="_flex">
                            <span>Didn't receive an email?</span> 
                            <span class="_ml-1 _underline" 
                                [ngClass]="darkTheme ? '_link-dark' : '_link'" 
                                (click)="resetPasswordSuccess = false">
                                    Resend
                                </span>
                        </span>
                        <span class="_flex _items-center _mb-2 _cursor-pointer _-ml-3" 
                            (click)="toggleResetPasswordView(false)">
                            <i class="fa-light fa-arrow-left"></i>
                            <span class="_ml-1 _underline" [ngClass]="darkTheme ? '_link-dark' : '_link'">Login</span>
                        </span>
                    </div>
                 
                    <!-- Temporarily remove social login -->
                    <ng-container *ngIf="false">
                        <div class="_mt-5 _mb-3 _text-sm"
                            [ngClass]="darkTheme ? '_text-white _hr-lines-dark' : '_text-black _hr-lines'">
                            Or login with
                        </div>

                        <div class="_flex _justify-center _gap-2">
                            <app-button
                                appTrackClick [metric]="'User Social Login Clicked'"
                                [properties]="{provider: 'Google'}"
                                class="_w-1/2"
                                modifierClassNames="_w-full"
                                [type]="darkTheme ? 'primary-dark' : 'primary'"
                                [loading]="loginInProgress === socialConnections.google"
                                [onClick]="socialLogin.bind(this, socialConnections.google)">
                                <i class="fa-brands fa-google _mr-2"></i>
                                Google
                            </app-button>
                            <app-button
                                appTrackClick [metric]="'User Social Login Clicked'"
                                [properties]="{provider: 'Microsoft'}"
                                class="_w-1/2"
                                modifierClassNames="_w-full"
                                [type]="darkTheme ? 'primary-dark' : 'primary'"
                                [loading]="loginInProgress === socialConnections.microsoft"
                                [onClick]="socialLogin.bind(this, socialConnections.microsoft)">
                                <i class="fa-brands fa-microsoft _mr-2"></i>
                                Microsoft
                            </app-button>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div data-tab-content-index="2">
                <div class="sm-max:_max-w-500px _mx-auto">
                    <div class="_h3 _mb-4"
                         [ngClass]="[
                            darkTheme ? '_text-white' : '_text-black',
                            role ? '_text-center' : '_text-left'
                        ]">
                        {{  role ?
                            'Please confirm your details to accept the invitation.' :
                            isSelfSingupForHotel ?
                            'Want to add your property to Reservest? Please submit your details here.' :
                            isSelfSignupForConsumer ?
                            'Sign up to book luxury villas and hotels.' :
                            'Sign up for free as an agent for over 3,000 luxury listings.'
                        }}
                    </div>

                    <div *ngIf="signupError"
                         class="_my-4 _w-full _text-center _text-black _pill _bg-white _border _border-error-red">
                        <i class="fa-regular fa-sharp fa-circle-xmark _text-error-red _mr-1"></i>
                        {{ signupErrorMessage }}
                    </div>

                    <div *ngIf="socialLoginError" class="_my-4 _w-full _text-center _text-black _pill _bg-white _border _border-error-red">
                        <i class="fa-regular fa-sharp fa-circle-xmark _text-error-red _mr-1"></i>
                        Please enter your phone number and accept our terms & conditions to proceed.
                    </div>

                    <div *ngIf="showLoginForExistingUser || inviteAccepted"
                        class="_my-4 _w-full _text-center _text-black _pill _bg-white _border _border-yellow-600">
                        <i class="fa-light fa-circle-exclamation _text-yellow-600 _mr-1"></i>
                        {{ inviteAccepted ? 'This invitation has already been accepted. Please log in or create a new account.' : 'An account already exists with this email, please log in below.' }}
                    </div>

                    <div *ngIf="showLoginForExistingUser && (loginError || onloadMessage.type === 'error')"
                        class="_my-4 _w-full _text-center _text-black _pill _bg-white _border _border-error-red">
                        <i class="fa-regular fa-sharp fa-circle-xmark _text-error-red _mr-1"></i>
                        {{ loginError ? loginErrorMessage : onloadMessage.message }}
                    </div>

                    <div *ngIf="inviteAccepted">
                        <div class="_flex _flex-col _items-center"
                            [ngClass]="darkTheme ? '_text-white' : '_text-black'">
                            <div class="_flex _mb-2">
                                <a href="/onboarding"
                                    class="_ml-2 _underline"
                                    [ngClass]="darkTheme ? '_link-dark' : '_link'"
                                    tabindex="0">
                                    Log in
                                </a>
                                <a [href]="role === Role.TravelAgent || role === Role.TravelAgentBusinessOwner ? '/onboarding?self_signup=travel-agent&signup=true' : '/onboarding?self_signup=hotel&signup=true'"
                                    class="_ml-2 _underline"
                                    [ngClass]="darkTheme ? '_link-dark' : '_link'"
                                    tabindex="0">
                                    Create account
                                </a>
                            </div>
                        </div>
                    </div>

                    <form [formGroup]="signupForm" *ngIf="!inviteAccepted">
                        <div class="_flex _gap-1">
                            <app-form-input-text
                                class="_w-1/2"
                                [value]="formData?.signupFirstName ? formData.signupFirstName : ''"
                                appTrackInput [metric]="'User Firstname Entered'"
                                label="Firstname"
                                placeholderText="Enter your firstname"
                                [darkTheme]="darkTheme"
                                fieldId="signupFirstname">
                            </app-form-input-text>

                            <app-form-input-text
                                class="_w-1/2"
                                [value]="formData?.signupLastName ? formData.signupLastName : ''"
                                appTrackInput [metric]="'User Surname Entered'"
                                label="Surname"
                                placeholderText="Enter your surname"
                                [darkTheme]="darkTheme"
                                fieldId="signupSurname">
                            </app-form-input-text>
                        </div>

                        <app-form-input-phone
                            appTrackInput [metric]="'User Phone Number Entered'"
                            [darkTheme]="darkTheme"
                            fieldId="signupPhoneNumber">
                        </app-form-input-phone>

                        <app-form-input-email
                            appTrackInput [metric]="'User Email Entered'"
                            [value]="formData?.signupEmail"
                            [darkTheme]="darkTheme"
                            fieldId="signupEmail">
                        </app-form-input-email>

                        <app-form-input-password
                            *ngIf="role && !showLoginForExistingUser"
                            appTrackInput [metric]="'User Password Entered'"
                            type="set"
                            [darkTheme]="darkTheme"
                            fieldId="signupPassword">
                        </app-form-input-password>

                        <app-form-input-password
                            *ngIf="role && showLoginForExistingUser"
                            appTrackInput [metric]="'User Password Entered'"
                            type="get"
                            [darkTheme]="darkTheme"
                            fieldId="signupAutoLoginPassword">
                        </app-form-input-password>

                        <app-form-select
                            *ngIf="isSelfSignupForTA"
                            label="Who you are"
                            placeholderText="Select the most accurate description"
                            fieldId="signupTravelAgentRole"
                            [selected]="this.formData.signupTravelAgentType"
                            [darkTheme]="darkTheme"
                            [required]=true
                            [options]="[
                                {
                                    label: 'Travel Agent',
                                    value: this.travelAgentType.travelAgent
                                },
                                {
                                    label: 'Tour Operator',
                                    value: this.travelAgentType.tourOperator
                                },
                                {
                                    label: 'Travel Planner / Designer',
                                    value: this.travelAgentType.travelPlannerDesigner
                                },
                                {
                                    label: 'Traveller',
                                    value: this.travelAgentType.traveller
                                }
                            ]">
                        </app-form-select>

                        <!-- Password field for consumers and verified travel agents -->
                        <div *ngIf="!role && (isSelfSignupForConsumer || (isSelfSignupForTA && isVerifiedTravelAgent))">
                            <app-form-input-password
                                [required]="true"
                                appTrackInput [metric]="'User Password Entered'"
                                type="set"
                                [darkTheme]="darkTheme"
                                fieldId="signupPassword">
                            </app-form-input-password>
                        </div>

                        <!-- Company fields only for travel agents -->
                        <div *ngIf="!role && !isSelfSignupForConsumer && !isSelfSingupForHotel"
                             [ngClass]="{'_hidden' : isSelfSignupForTA && !isVerifiedTravelAgent}">
                            <app-form-input-text
                                [required]="isSelfSignupForTA && isVerifiedTravelAgent"
                                label="Company name"
                                placeholderText="Enter your company name"
                                [darkTheme]="darkTheme"
                                fieldId="signupCompanyName"
                                [punctuationAndSpecialCharactersAllowed]="true"
                                [value]="formData?.signupCompanyName ? formData.signupCompanyName : ''"
                                [numbersAllowed]="true">
                            </app-form-input-text>
                        </div>

                        <!-- Revenue selector only for travel agents -->
                        <div *ngIf="!role && !isSelfSignupForConsumer && !isSelfSingupForHotel"
                             [ngClass]="{'_hidden' : isSelfSignupForTA && !isVerifiedTravelAgent}">
                            <app-form-select
                                label="What is your annual booking revenue?"
                                placeholderText="Select the most accurate description"
                                fieldId="signupAnnualBookingRevenue"
                                [darkTheme]="darkTheme"
                                [required]="isSelfSignupForTA && isVerifiedTravelAgent"
                                [selected]="this.formData.signupBookingRevenue"
                                [options]="annualBookingRevenueOptions">
                            </app-form-select>
                        </div>

                        <!-- Consortium fields only for travel agents -->
                        <div *ngIf="!role && !isSelfSignupForConsumer && !isSelfSingupForHotel"
                             [ngClass]="{'_hidden' : isSelfSignupForTA && !isVerifiedTravelAgent}">
                            <app-form-input-text
                                [required]="false"
                                label="Consortium / Host Agency name"
                                placeholderText="Enter your Consortium / Host Agency name (if applicable)"
                                [darkTheme]="darkTheme"
                                fieldId="signupConsortiumName"
                                [punctuationAndSpecialCharactersAllowed]="true"
                                [value]="formData?.signupConsortiumName ? formData.signupConsortiumName : ''"
                                [numbersAllowed]="true"
                                [minLength]="1">
                            </app-form-input-text>
                        </div>

                        <!-- Membership number only for travel agents -->
                        <div *ngIf="!role && !isSelfSignupForConsumer && !isSelfSingupForHotel"
                             [ngClass]="{'_hidden' : isSelfSignupForTA && !isVerifiedTravelAgent}">
                            <app-form-input-text
                                [required]="false"
                                label="Membership / association number"
                                placeholderText="Enter your membership number (if applicable)"
                                [darkTheme]="darkTheme"
                                fieldId="signupConsortiumMembershipNumber"
                                [punctuationAndSpecialCharactersAllowed]="true"
                                [value]="formData?.signupConsortiumMembershipNumber ? formData.signupConsortiumMembershipNumber : ''"
                                [numbersAllowed]="true">
                            </app-form-input-text>
                        </div>

                        <!-- Hotel specific fields -->
                        <app-form-input-text
                            *ngIf="isSelfSingupForHotel"
                            label="Company website"
                            placeholderText="Enter you website"
                            [darkTheme]="darkTheme"
                            fieldId="signupCompanyWebsite"
                            [punctuationAndSpecialCharactersAllowed]="true">
                        </app-form-input-text>

                        <app-form-text-area
                            *ngIf="isSelfSingupForHotel"
                            label="Brief description of your property"
                            placeholderText="6-bedroom villa in the Algarve with a private pool and ocean views."
                            [darkTheme]="darkTheme"
                            fieldId="signupPropertyDescription">
                        </app-form-text-area>

                        <!-- Terms and conditions for all users -->
                        <app-form-checkbox
                            appTrackClick [metric]="'User Terms and Conditions Clicked'"
                            fieldId="termsAndConditions"
                            [required]=true
                            [checked]=true
                            value="terms_and_conditions"
                            modifierClassname="_mt-5 _mb-6">
                            <span class="label _ml-2 _cursor-pointer _text-sm"
                                [ngClass]="darkTheme ? '_text-white' : '_text-black'">
                                I have read, understood and agree to the 
                                <app-legal-document-links
                                    [customClass]="darkTheme ? '_link-dark _inline' : '_link _inline'"
                                    [legalDocumentType]="LegalDocumentType.terms"
                                    [text]="'terms & conditions'">
                                </app-legal-document-links>
                                and 
                                <app-legal-document-links
                                    [customClass]="darkTheme ? '_link-dark _inline' : '_link _inline'"
                                    [legalDocumentType]="LegalDocumentType.privacy"
                                    [text]="'privacy policy'">
                                </app-legal-document-links> 
                            </span>
                        </app-form-checkbox>

                        <app-button
                            appTrackClick [metric]="'User Signup Clicked'"
                            [disabled]="!signupForm.valid"
                            [loading]="signupInProgress === 'user-credentials'"
                            [onClick]="signup.bind(this)"
                            [type]="darkTheme ? 'primary-dark' : 'primary'"
                            modifierClassNames="_w-full _mb-4">
                            {{ showLoginForExistingUser ? 'Log in' :  'Create your account' }}
                        </app-button>
                    </form>

                    <div *ngIf="!role" class="_flex _flex-col _items-center"
                         [ngClass]="darkTheme ? '_text-white' : '_text-black'">
                        <div class="_flex _mb-2">
                            Already have an account?
                            <span class="_ml-2 _underline"
                                [ngClass]="darkTheme ? '_link-dark' : '_link'"
                                (click)="trackCurrentTab(1)"
                                (keydown.enter)="trackCurrentTab(1)"
                                tabindex="0">
                                Log in
                            </span>
                        </div>
                    </div>

                    <!-- Temporarily remove social login -->
                    <ng-container *ngIf="false">
                        <div class="_hr-lines _my-3 _text-sm"
                            [ngClass]="darkTheme ? '_text-white _hr-lines-dark' : '_text-black _hr-lines'">
                            Or sign up with
                        </div>

                        <div class="_flex _justify-center _gap-2">
                            <app-button
                                appTrackClick [metric]="'User Social Login Clicked'"
                                [properties]="{provider: 'Google'}"
                                class="_w-1/2"
                                modifierClassNames="_w-full"
                                [type]="darkTheme ? 'primary-dark' : 'primary'"
                                [loading]="signupInProgress === socialConnections.google"
                                [onClick]="socialSignup.bind(this, socialConnections.google)">
                                <i class="fa-brands fa-google _mr-2"></i>
                                Google
                            </app-button>
                            <app-button
                                appTrackClick [metric]="'User Social Login Clicked'"
                                [properties]="{provider: 'Microsoft'}"
                                class="_w-1/2"
                                modifierClassNames="_w-full"
                                [type]="darkTheme ? 'primary-dark' : 'primary'"
                                [loading]="signupInProgress === socialConnections.microsoft"
                                [onClick]="socialSignup.bind(this, socialConnections.microsoft)">
                                <i class="fa-brands fa-microsoft _mr-2"></i>
                                Microsoft
                            </app-button>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </app-tabs>
</div>
